module.exports = __webpack_public_path__ + "static/img/index_snapbot.9cf826c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/index_snapbot.png
// module id = rYX0
// module chunks = 1